var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { IEventsDataSourceType } from '../../DataSource/EventsDataSource/IEventsDataSource';
import { injectable } from '../../Decorators/Injectable';
import { inject } from '../../Decorators/Inject';
import { CoreConfig } from '../../../CoreConfig';
import { Observable } from '../../Observable/Observable';
let CoreEventsRepository = class CoreEventsRepository {
    constructor(eventsDataSource) {
        this.eventsDataSource = eventsDataSource;
        this.updatePayloadEvent = new Observable();
        this.eventsDataSource.getExternalEvent().observe(this, event => {
            if ((event === null || event === void 0 ? void 0 : event.event) === 'update_payload') {
                this.updatePayloadEvent.next(event);
            }
        });
    }
    getUpdatePayloadEvent() {
        return this.updatePayloadEvent;
    }
    getDidUpdateSid() {
        return this.eventsDataSource.getEvent(CoreConfig.moduleName, 'did_update_sid');
    }
    sendDidDismiss(moduleName, data) {
        return this.eventsDataSource.sendEvent(moduleName || CoreConfig.moduleName.toLowerCase(), {
            module: moduleName || CoreConfig.moduleName.toLowerCase(),
            event: 'did_dismiss',
            data: Object.assign({ isSuccessful: true }, data)
        });
    }
};
CoreEventsRepository = __decorate([
    injectable({ type: 'singleton' }),
    __param(0, inject(IEventsDataSourceType)),
    __metadata("design:paramtypes", [Object])
], CoreEventsRepository);
export { CoreEventsRepository };
